import PageContainer from '@src/components/Layout/PageContainer'
import DocumentList from './DocumentList'

const AutomationListPage = () => {
  return (
      <PageContainer sx={{ mt: 1 }}>
        <DocumentList />
      </PageContainer>
  )
}

export default AutomationListPage
